import { render, staticRenderFns } from "./ArchiveTools.vue?vue&type=template&id=ba09fc36&"
import script from "./ArchiveTools.vue?vue&type=script&lang=js&"
export * from "./ArchiveTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports